import { Home } from '@mui/icons-material'
import { RouteKeyEnum } from 'src/routes'

export const TAG_DIED_MANAGEMENT_BREADCRUMB_ITEMS = [
  {
    title: 'Home',
    route_key: RouteKeyEnum.HOME,
    icon: Home,
  },
  {
    title: 'Tag De-ID Management',
    route_key: RouteKeyEnum.TAG_DEID_MANAGEMENT,
  },
]

export const ROW_PER_PAGE_OPTIONS = [10, 25, 50]
